export const setPageLoading = (status: boolean) => {
  const loadingEl = document.getElementById('pageLoadingContainer');
  loadingEl?.setAttribute('style', status ? '' : 'display: none;');
};
